import { toCountryCode } from './countryCodes';
import { MultipleChoiceBlock } from 'concepts/Extraction/Blocks/MultipleChoice/MultipleChoiceBlock';
import { OptionBlock } from 'concepts/Extraction/Blocks/shared/Option/Option/OptionBlock';

export type MatchResult =
  | { kind: 'option'; optionId: string }
  | { kind: 'other'; otherOptionId: string; text: string }
  | null;

type Matcher = (
  suggestion: string,
  options: OptionBlock[]
) => OptionBlock | null;

const defaultMatcher: Matcher = (suggestion, options) => {
  const normalized = suggestion.trim().toLowerCase();
  return (
    options.find(
      (option) => option.label.trim().toLowerCase() === normalized
    ) ?? null
  );
};

const countryMatcher: Matcher = (suggestion, options) => {
  const suggestionCode = toCountryCode(suggestion);
  if (!suggestionCode) return null;
  return (
    options.find((option) => toCountryCode(option.label) === suggestionCode) ??
    null
  );
};

const MATCHERS: Record<string, Matcher> = {
  country: countryMatcher,
};

export const matchValueToOption = (
  value: string,
  options: OptionBlock[],
  autoDocExtField: string
): OptionBlock | null => {
  const matcher = MATCHERS[autoDocExtField] ?? defaultMatcher;
  const matched = matcher(value, options);

  if (matched) return matched;

  if (matcher != defaultMatcher) {
    return defaultMatcher(value, options);
  }

  return null;
};

export const matchSuggestionToOption = (
  suggestion: string | null,
  block: MultipleChoiceBlock,
  autoDocExtField: string
): MatchResult => {
  if (!suggestion) return null;

  const matched = matchValueToOption(
    suggestion,
    block.options,
    autoDocExtField
  );

  if (matched) {
    return { kind: 'option', optionId: matched.id };
  }

  if (block.otherOption) {
    return {
      kind: 'other',
      otherOptionId: block.otherOption.id,
      text: suggestion,
    };
  }

  return null;
};
